export function PopularShows() {
  return <div>Popular</div>;
}

PopularShows.propTypes = {};
